import React, { useMemo } from 'react';
import ButtonComponent from 'components/button/buttonComponent';
import { useGetMyBillingPlanQuery } from 'graphql/generated/hasura';
import { useNavigate } from 'react-router-dom';
import { SUBSCRIPTION_PAGE } from 'utilities/routes';

const replace = (template: string, amount: number) => {
  const token = '{cost}';
  const replacements = [amount, amount / 3];
  let i = 0;
  return template.replace(new RegExp(token, 'g'), () => {
    return replacements[i++]?.toString() || '';
  });
};

const ExpiringSubscriptionOutlet = () => {
  const navigate = useNavigate();
  const { data: currentPlan } = useGetMyBillingPlanQuery();
  const plan = useMemo(() => currentPlan?.getMyBillingPlan, [currentPlan]);

  return (
    <div className="grid grid-cols-12 bg-alert-negative gap-2.5 items-center w-full py-4 border border-t-gray-opacity-15 px-7 desktop:px-[135px]">
      <p className="text-white desktop:col-span-10 col-span-full font-semibold desktop:text-h5 text-base">
        {replace(
          'Your subscription has expired. Access to all features costs ${cost} for 3 months (${cost} per month).',
          plan?.amount ?? 0,
        )}
      </p>
      <div className="desktop:col-span-2 col-span-full">
        <ButtonComponent
          className="!text-xs bg-white border-transparent font-bold w-full"
          type="outlined-transparent"
          testID={'activate-subscription'}
          onClick={() => navigate(SUBSCRIPTION_PAGE)}
        >
          Activate Subscription
        </ButtonComponent>
      </div>
    </div>
  );
};

export default ExpiringSubscriptionOutlet;
